<template>
  <ra-card>
    <template slot="header">
      <p>Requests By Identity Type</p>
    </template>
    <template slot="content">
      <doughnut-chart
        v-if="dataAvailable"
        :data="requestChart.data"
        :labels="requestChart.labels"
      />
      <ra-empty-state v-else :type="'pie-chart'" />
    </template>
  </ra-card>
</template>

<script>
import apiConstants from "@/apiConstants";
import DoughnutChart from "@/components/Chart/DoughnutChart";

export default {
  name: "VerificationsByType",
  components: {
    DoughnutChart
  },
  data() {
    return {
      labels: [],
      data: [],
      noAccessCodes: apiConstants.NO_ACCESS_CODES
    };
  },
  computed: {
    requestChart() {
      const labels = this.labels;
      const data = this.data;

      return { data, labels };
    },

    dataAvailable() {
      return this.labels.length && this.data.length;
    }
  },

  created() {
    this.requests();
  },

  methods: {
    requests() {
      const apiUrl = "services/logs";
      const byType = JSON.stringify([
        {
          field: "adapterEndpoint.endpoint.short_name",
          alias: "type"
        }
      ]);
      const aggs = JSON.stringify([
        {
          field: "id",
          func: "count",
          alias: "total_count"
        }
      ]);
      const params = `aggs=${aggs}&group_by=${byType}`;

      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: params
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.SERVICES
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
          } else {
            const list = resData.list;
            if (list.length) {
              const data = list.map(ls => ls.total_count);
              this.labels = list.map((ls, i) => `${ls.type}(${data[i]})`);
              this.data = data;
            }
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
        });
    }
  }
};
</script>

<style scoped>
.ra-card {
  height: 93%;
}
</style>
